export default "__VITE_ASSET__CfFMckp$__"